import { Link } from 'react-router';
import { APP_NAME } from '../config';
import './site-footer.css';

export function SiteFooter() {
  return (
    <footer className="site-footer">
      <div className="site-footer-inner">
        <p className="mono" style={{ margin: 0 }}>
          {APP_NAME} finds albums and opens them in{' '}
          <a href="https://open.spotify.com/" target="_blank" rel="noopener noreferrer">
            Spotify
          </a>
          . Artist data and artwork come from Spotify. Not affiliated with or endorsed by Spotify.
        </p>
        <nav aria-label="Legal">
          <Link to="/privacy">Privacy</Link>
          <Link to="/terms">Terms</Link>
        </nav>
      </div>
    </footer>
  );
}
